<div class="courses-cont   ">
  <h3>
    {{ data.title }}
  </h3>

  <!-- Desktop view -->
  <div class="row m-0 p-0">


    <ng-container *ngIf="!isMobile">
      <div class="col-4" *ngFor="let item of filteredServices">
        <div class="course-card">
          <div class="card-img">
            <div class="price">{{ item.price }}</div>
            <img [src]="item.imageIconPath" [alt]="item.imageAlt" />
          </div>
          <div class="card-content">
            <h1>{{ item.titleTr }}</h1>
            <p class="mb-4">{{ item.summary }}</p>
            <a class="btn" [href]="getDetailsUrl(item)" *ngIf="data.isDetails">{{ item.btnText }}</a>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- Mobile carousel -->
    <div class="mobile-carousel-wrapper" *ngIf="isMobile">
      <div class="carousel-viewport">
        <div class="carousel-track" #carouselTrack (touchstart)="onTouchStart($event)" (touchmove)="onTouchMove($event)"
          (touchend)="onTouchEnd($event)">
          <div class="carousel-slide" *ngFor="let item of filteredServices">
            <div class="course-card">
              <div class="card-img">
                <div class="price">{{ item.price }}</div>
                <img [src]="item.imageIconPath" [alt]="item.imageAlt" />
              </div>
              <div class="card-content">
                <h1>{{ item.titleTr }}</h1>
                <p class="mb-4">{{ item.summary }}</p>
                <a class="btn" [href]="getDetailsUrl(item)" *ngIf="data.isDetails">{{ item.btnText }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Dots indicator -->
      <div class="carousel-dots">
        <span class="dot" *ngFor="let item of filteredServices; let i = index" [class.active]="i === activeIndex"
          (click)="goToSlide(i)"></span>
      </div>
    </div>

    <button class="view-all-btn" *ngIf="filteredServices.length > 3">كل الدورات</button>
  </div>
</div>
<hr>